import { Text, Stack } from '@tiendanube/components';
import { CardWithTitle } from 'commons/components';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

function ConfigureProductsSkeleton() {
  const t = useTranslationCatalog();

  return (
    <Stack column align="stretch">
      <CardWithTitle
        title={t('products.order.productsWithoutStockCard.titleList')}
      >
        <Text.Skeleton size="featured" width="fill" />
        <Text.Skeleton size="featured" width="fill" />
      </CardWithTitle>
      <CardWithTitle
        title={t('products.search.productsWithoutStockSearchCard.title')}
      >
        <Text.Skeleton size="featured" width="fill" />
        <Text.Skeleton size="featured" width="fill" />
      </CardWithTitle>
      <Stack.Item />
    </Stack>
  );
}

export default ConfigureProductsSkeleton;
